// File imports
import PropTypes from 'prop-types';
import AddNewTag from './AddNewTag';
import CLColorPicker from './CLColorPicker';
import { visuallyHidden } from '@mui/utils';
import AddIcon from '@mui/icons-material/Add';
import Preloader from '../../../helpers/Preloader';
import SearchIcon from "@mui/icons-material/Search";
import CLTagsButtonGroup from './CLTagsButtonGroup';
import { timestamp } from '../../../utils/services';
import { stableSort } from '../CommentLibraryHelper';
import CLDeleteTags from './CLDeleteTagsConfirm';
import React, { useEffect, useMemo, useState } from 'react';
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';
import { TagsListApiPaginated } from '../../../utils/action';
import "../../../../assets/styles/containers/_clTagsSummary.scss";
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import "../../../../assets/styles/containers/_clTagsSummary.scss";
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { Paper, Button, Box, Grid, TextField, Typography, Table, TableBody, TableCell, TableContainer, TableRow, IconButton, TableHead, TableSortLabel, TablePagination, useTheme } from '@mui/material';
import { useLocation } from 'react-router-dom';
import toast from 'react-hot-toast';
import LastPageIcon from "@mui/icons-material/LastPage";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
/**
 *
 * TabPanel
 *
 * Renders a tab panel for the Comment Library
 */
function TabPanel(props) {
    // Destructuring props
    const { children, value, index, ...other } = props;
    // JSX
    return (
        <div
            role="tabpanel"
            hidden={value !== index} // Hides the tab panel when it's not selected
            id={`simple-tabpanel-${index}`} // Generates a unique ID for each tab panel
            aria-labelledby={`simple-tab-${index}`} // The ID of the tab
            {...other} // Spreads any other properties
        >
            {/* Renders the tab panel when it's selected */}
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography> {/* Renders the tab's content */}
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node, // The content of the tab
    index: PropTypes.number.isRequired, // The index of the tab
    value: PropTypes.number.isRequired, // The selected tab
};
/**
 * Creates a comparator function for sorting rows.
 *
 * @param {string} order - The sort order, either 'asc' or 'desc'
 * @param {string} orderBy - The property to sort by
 * @returns {function} - The comparator function
 */
function getComparator(order, orderBy) {
    /**
     * Comparator function that compares two rows based on the orderBy property
     *
     * @param {object} a - The first row
     * @param {object} b - The second row
     * @returns {number} - A negative number if a < b, positive if a > b, or 0 if equal
     */
    const descendingComparator = (a, b, orderBy) => {
        // If the property is a string, lowercase both values to compare
        if (typeof a[orderBy] === 'string') {
            const lowercaseA = a[orderBy].toLowerCase();
            const lowercaseB = b[orderBy].toLowerCase();

            if (lowercaseA < lowercaseB) {
                return -1;
            } else if (lowercaseA > lowercaseB) {
                return 1;
            }
        }
        // If the property is a number, compare normally
        if (a[orderBy] < b[orderBy]) {
            return -1;
        } else if (a[orderBy] > b[orderBy]) {
            return 1;
        }
        // Items are equal
        return 0;
    };
    // Based on the order, sort the rows in either ascending or descending order
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}
/**
 * Component for displaying Comment Library table
 */
const CLTags = (props) => {
    const { isHTCompany } = props;
    const [order, setOrder] = useState('asc'); // asc or desc order
    const [selected, setSelected] = useState([]); // selected rows
    const [orderBy, setOrderBy] = useState('calories'); // currently ordered by column
    const [showLoader, setShowLoader] = useState(false); // show loader indicator
    const [deletedTagId, setDeletedTagId] = useState(""); //id for delete tag
    const [commentListData, setCommentListData] = useState([]); // comment list data
    const [initialTableData, setInitialTableData] = useState([]); // initial table data to perform search
    const location = useLocation();
    const [totalListCount, setTotalListCount] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(parseInt(sessionStorage.getItem("tagsRowsPerPage"), 10) || 10);
    const [apiPageCount, setApiPageCount] = useState(0);
    const [page, setPage] = useState(0);
    const [search, setSearch] = useState("");
    const [parameters, setParameters] = useState({
        order: null,
        orderBy: null,
    })
    const handleopenAddNewTagModal = () => {
        setopenAddNewTagModal(true);
    } //modal toggle 
    const [openAddNewTagModal, setopenAddNewTagModal] = useState(false);
    const handleCloseAddNewTagModal = () => setopenAddNewTagModal(false);
    const [deleteLoader, setDeleteLoader] = useState(false);
    const [commentListInititalData, setCommentListInitialData] = useState([]); // initial comment list data
    const [deleteConfirmationModal, setDeleteConfirmationModal] = useState(false);
    const handleOpenConfirmationModal = (row) => {
        setDeleteConfirmationModal(true); setDeletedTagId({
            tag_id: row.id,
        })
    }
    const handleCloseConfirmationModal = () => setDeleteConfirmationModal(false);
    // API calls

    const GetCommentLibTagList = () => {
        const params = `?page=${apiPageCount + 1}&rows_per_page=${rowsPerPage}&search=${search || ""}&sort_direction=${parameters.order || ""}&sort_field=${parameters.orderBy || ""}`
        setShowLoader(true);
        TagsListApiPaginated(
            (response) => {
                const { data, message, success, pagination } = response.data;
                if (success) {
                    setCommentListData(data);
                    setTotalListCount(pagination?.total_count);
                    setShowLoader(false);
                } else {
                    console.log("else", message);
                }
            },
            "",
            isHTCompany ? "GET_COMMENT_LIB_TAGS_LIST_PAGINATED" : "GET_COMMENT_LIB_TAGS_LISTS",
            params,
            "GET"
        );
    };
    useEffect(() => {
        if (search !== "") {
            const delayDebounce = setTimeout(() => {
                if (search.trim() !== "") {
                    GetCommentLibTagList();
                }
            }, 1500);
            return () => clearTimeout(delayDebounce);
        } else {
            GetCommentLibTagList();
        }

    }, [rowsPerPage, apiPageCount, search, order]);

    const handleSearchFilter = (value) => {
        setPage(0);
        setApiPageCount(0);
        setSearch(value);
    };

    const handleChangePage = (event, newPage) => {
        setApiPageCount(newPage);
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        const newRowsPerPage = parseInt(event.target.value, 10);
        setRowsPerPage(newRowsPerPage);
        sessionStorage.setItem("tagsRowsPerPage", newRowsPerPage);
        setPage(0);
        setApiPageCount(0);
    };

    // Handle head cells, sorting and selection
    const EnhancedTableHead = (props) => {
        /**
         * Handle table head cells, sorting and selection
         * @param {object} props table head props
         */
        // eslint-disable-next-line
        const { onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } =
            props;
        const createSortHandler = (property) => (event) => {
            onRequestSort(event, property);
        };

        return (
            <TableHead>
                <TableRow>
                    {headCells?.map((headCell) => (
                        <TableCell
                            key={headCell.id}
                            align={'left'}
                            padding={headCell.disablePadding ? 'none' : 'normal'}
                            sortDirection={orderBy === headCell.id ? order : false}
                            className='cl-table-head'
                            style={{ width: headCell.width ? headCell.width : "" }}
                        >
                            <TableSortLabel
                                active={orderBy === headCell.id}
                                direction={orderBy === headCell.id ? order : 'asc'}
                                onClick={createSortHandler(headCell.id)}
                                IconComponent={() =>
                                    (headCell.id !== "order" && headCell.id !== "global" && headCell.id !== "color") ? (
                                        <UnfoldMoreIcon className='cl-sort-icon' />
                                    ) : (
                                        ""
                                    )
                                }
                            >
                                {headCell.label}
                                {orderBy === headCell.id ? (
                                    <Box component="span" sx={visuallyHidden}>
                                        {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                    </Box>
                                ) : null}
                            </TableSortLabel>
                        </TableCell>
                    ))}
                </TableRow>
            </TableHead>
        );
    }

    EnhancedTableHead.propTypes = {
        numSelected: PropTypes.number.isRequired,
        onRequestSort: PropTypes.func.isRequired,
        onSelectAllClick: PropTypes.func.isRequired,
        order: PropTypes.oneOf(['asc', 'desc']).isRequired,
        orderBy: PropTypes.string.isRequired,
        rowCount: PropTypes.number.isRequired,
    };

    const headCells = [
        {
            id: 'name',
            numeric: false,
            disablePadding: false,
            label: 'Tag',
            width: location.search !== "?zero-state" ? 610 : 1010
        },

        {
            id: 'color',
            numeric: false,
            disablePadding: false,
            label: 'Color',
            width: location.search !== "?zero-state" ? 110 : 180
        },
        {
            id: 'comments_count',
            numeric: false,
            disablePadding: false,
            label: 'Times used',
            width: location.search !== "?zero-state" ? 210 : 150
        },
        {
            id: 'global',
            numeric: false,
            disablePadding: false,
            label: '',
        },

    ];

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === "asc";
        setOrder(isAsc ? "desc" : "asc");
        setOrderBy(property);
        setParameters({
            order: order,
            orderBy: property,
        });
        setPage(0);
        setApiPageCount(0);
    };

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const selectedComment = commentListData?.map((n) => n.id);
            setSelected(selectedComment);
            return;
        }
        setSelected([]);
    };
    const isSelected = (id) => selected.indexOf(id) !== -1;

    const visibleRows = useMemo(() => {
        const dataToSort = commentListData?.length > 0 ? commentListData : [];
        return dataToSort;
    }, [commentListData, order, orderBy,]);

    const reorder = (list, startIndex, endIndex) => {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);
        return result;
    };
    const onDragEnd = (result) => {
        // dropped outside the list
        if (!result.destination) {
            return;
        }
        const items = reorder(
            commentListData,
            result.source.index,
            result.destination.index
        );
        items.forEach((element, i) => {
            element.order = i + 1;
            element.updated_at = timestamp();
            return element
        });
        setCommentListData(items);
    };
    // color change
    const handleColorChange = (id, color) => {
        const updatedRows = commentListData.map((row) =>
            row.id === id ? { ...row, color: color } : row
        );
        setCommentListData(updatedRows);
    };

    function TablePaginationActions(props) {
        const theme = useTheme();
        const { count, page, rowsPerPage, onPageChange } = props;

        /**
         * Handles the click of the first page button
         *
         * @param {React.MouseEvent<HTMLElement>} event - The click event
         */
        const handleFirstPageButtonClick = (event) => {
            onPageChange(event, 0);
        };

        /**
         * Handles the click of the back button
         *
         * @param {React.MouseEvent<HTMLElement>} event - The click event
         */
        const handleBackButtonClick = (event) => {
            onPageChange(event, page - 1);
        };

        /**
         * Handles the click of the next button
         *
         * @param {React.MouseEvent<HTMLElement>} event - The click event
         */
        const handleNextButtonClick = (event) => {
            onPageChange(event, page + 1);
        };

        /**
         * Handles the click of the last page button
         *
         * Calculates the last page based on the total number of rows
         * and the rows per page, and passes that value to the onPageChange function
         *
         * @param {React.MouseEvent<HTMLElement>} event - The click event
         */
        const handleLastPageButtonClick = (event) => {
            const lastPage = Math.max(0, Math.ceil(count / rowsPerPage) - 1);
            onPageChange(event, lastPage);
        };

        return (
            <Box sx={{ flexShrink: 0, ml: 5 }}>
                <IconButton
                    onClick={handleFirstPageButtonClick}
                    disabled={page === 0} aria-label="first page" sx={{ ml: 3 }}>
                    {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
                </IconButton>
                <IconButton
                    onClick={handleBackButtonClick}
                    disabled={page === 0} aria-label="previous page" sx={{ ml: 3 }}>
                    {theme.direction === "rtl" ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
                </IconButton>
                <IconButton
                    onClick={handleNextButtonClick}
                    disabled={page >= Math.ceil(count / rowsPerPage) - 1} aria-label="next page" sx={{ ml: 3 }}>
                    {theme.direction === "rtl" ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
                </IconButton>
                <IconButton
                    onClick={handleLastPageButtonClick}
                    disabled={page >= Math.ceil(count / rowsPerPage) - 1} aria-label="last page">
                    {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
                </IconButton>
            </Box>
        );
    }


    const handleSaveTag = async (row) => {
        const payload = {
            name: row?.name,
            color: row?.color
        };
        try {
            TagsListApiPaginated(
                (response) => {
                    const { message, success, status_code } = response.data;
                    if (status_code == 201) {
                        toast.success(message);
                        GetCommentLibTagList();
                    } else {
                        toast.error(message);
                        console.error("else", message);
                    }
                },
                payload,
                isHTCompany ? "ADD_COMMENT_LIB_TAG" : "GET_COMMENT_LIB_TAGS_LISTS",
                "",
                "POST"
            );
        } catch (error) {
            console.error("Error updating summary:", error);
        }
    };


    const handleTagTitleChange = (event, row) => {
        const updatedTagValue = event.target.value;
        const payload = {
            tag_id: row?.id,
            name: updatedTagValue,
            color: row?.color,
        };

        TagsListApiPaginated(
            (response) => {
                const { message, success } = response.data;
                if (success) {
                    toast.success(message);
                    setShowLoader(false);
                    GetCommentLibTagList()
                } else {
                    toast.error(message);
                    console.error("else", message);
                }
            },
            payload,
            isHTCompany ? "EDIT_TAGS_LIST" : "GET_COMMENT_LIB_TAGS_LISTS",
            "",
            "PUT"
        );
    };



    // render JSX
    return (
        <>
            <Preloader showPreloader={showLoader} />
            <AddNewTag open={openAddNewTagModal} handleClose={handleCloseAddNewTagModal} setopenAddNewTagModal={setopenAddNewTagModal} GetCommentLibTagList={GetCommentLibTagList} isHTCompany={isHTCompany}
                existingTagNames={(commentListData || []).map((t) => (t?.name ?? ""))}
            />
            <Box className="cl-tags-page" sx={{ width: '100%', paddingX: "30px" }}>
                <div className="cl-tags-sticky-top">
                    <Grid container className='cl-search-container'>
                        <Grid item xs={6} md={6} lg={2} className='cl-search-bar'>
                            <div className="cl-search">
                                <TextField
                                    size="small"
                                    id="search-bar"
                                    variant="outlined"
                                    placeholder="Search in table"
                                    onChange={(e) => handleSearchFilter(e.target.value)}
                                />
                                <SearchIcon className="cl-search-icon" />
                            </div>
                        </Grid>
                        <Grid item xs={6} md={6} lg={10} sx={{ gap: "5px" }}>
                            <Button startIcon={<AddIcon />} className='add-new-btn' onClick={handleopenAddNewTagModal}><span>Add new</span></Button>
                        </Grid>
                    </Grid>
                </div>
                <div className="cl-tags-table-area">
                    <Paper className="cl-tags-table-paper" elevation={0}>
                        <TableContainer
                            className=' cl-tags-table-container'
                            component={Paper}
                        >
                            <Table aria-label="simple table" stickyHeader>
                                <EnhancedTableHead
                                    order={order}
                                    orderBy={orderBy}
                                    numSelected={selected.length}
                                    onRequestSort={handleRequestSort}
                                    rowCount={commentListData?.length}
                                    onSelectAllClick={handleSelectAllClick}
                                />
                                <TableBody>
                                    {location.search !== "?zero-state" ? visibleRows?.map((row, index) => {
                                        const isItemSelected = isSelected(row.id);
                                        const labelId = `enhanced-table-checkbox-${index}`;
                                        return (
                                            <TableRow
                                                hover
                                                tabIndex={-1}
                                                key={row.id}
                                                selected={isItemSelected}
                                                sx={{ cursor: 'pointer' }}
                                                aria-checked={isItemSelected}
                                            >
                                                <TableCell
                                                    padding="none"
                                                    sx={{ p: "0px 10px 0px 10px" }}
                                                    className='cl-title-col'
                                                    align="left"
                                                >
                                                    <TextField
                                                        className="cl_tags_textfield"
                                                        sx={{ mt: -1, mb: 1 }}
                                                        defaultValue={row?.name}
                                                        onBlur={(e) => e.target.value !== row.name && handleTagTitleChange(e, row)}
                                                    />
                                                </TableCell>
                                                <TableCell
                                                    sx={{ padding: "10px 10px 0px 10px" }}
                                                    padding="none"
                                                    className='cl-global-col'
                                                    align="left"
                                                    style={{ width: "200px", position: "relative" }}
                                                >
                                                    <CLColorPicker
                                                        isHTCompany={isHTCompany}
                                                        row={row}
                                                        onColorChange={handleColorChange}
                                                        GetCommentLibTagList={GetCommentLibTagList}
                                                        readOnly={false}
                                                    />
                                                </TableCell>
                                                <TableCell
                                                    sx={{ padding: "0px 0px 5px 15px" }}
                                                    padding="none"
                                                    className='cl-rating-col'
                                                    align="left"
                                                >
                                                    <span className='times-used-text'>{row?.comments_count}</span>
                                                </TableCell>
                                                <TableCell
                                                    padding="none"
                                                    align="right"
                                                    width="160px"
                                                    sx={{ position: "relative" }}
                                                >
                                                    <CLTagsButtonGroup
                                                        isHTCompany={isHTCompany}
                                                        handleOpenConfirmationModal={handleOpenConfirmationModal}
                                                        row={row}
                                                        setDeletedTagId={setDeletedTagId}
                                                        deletedTagId={deletedTagId}
                                                        name={"tags"}
                                                    />
                                                </TableCell>
                                            </TableRow>
                                        );
                                    }) : <TableRow style={{ height: "100%" }}>
                                        <TableCell colSpan={999} style={{ padding: 0 }}>
                                            <Box
                                                display="flex"
                                                flexDirection="column"
                                                alignItems="center"
                                                justifyContent="center"
                                                height="100%"
                                                minHeight="360px" // force some height if table has no rows
                                                textAlign="center"
                                            >
                                                <Typography className="cl-empty-text">No tags found</Typography>
                                            </Box>
                                        </TableCell>
                                    </TableRow>}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Paper>
                </div>

                <div className="cl-tags-sticky-bottom">
                    <div className="cl-tags-pagination-inner">
                        <TablePagination
                            rowsPerPageOptions={[10, 25, 50, 200]}
                            component="div"
                            count={totalListCount}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            ActionsComponent={TablePaginationActions}
                        />
                    </div>
                </div>

                <CLDeleteTags setDeleteLoader={setDeleteLoader} deleteLoader={deleteLoader} deleteConfirmationModal={deleteConfirmationModal} handleCloseConfirmationModal={handleCloseConfirmationModal} deletedTagId={deletedTagId} setDeletedTagId={setDeletedTagId} setDeleteConfirmationModal={setDeleteConfirmationModal} GetCommentLibTagList={GetCommentLibTagList} isHTCompany={isHTCompany} />
            </Box>
        </>
    )
}

export default CLTags;